type FormRefPrefix = 'PRF' | 'MIF' | 'PAR';

const extractRefNumber = (id: string): string => {
  const match = id.match(/^(?:EV|EVT|INC)-(\d+)/i);
  if (match) return match[1];
  const digits = id.replace(/[^\d]/g, '');
  return digits || id;
};

function nextFormSerial(prefix: FormRefPrefix): number {
  const storageKey = `c2_${prefix.toLowerCase()}_serial`;
  const current = parseInt(localStorage.getItem(storageKey) || '0', 10);
  const next = current + 1;
  localStorage.setItem(storageKey, String(next));
  return next;
}

/** {PREFIX}-{seq}-EV-{evNum}-INC-{incNum} — global serial per form type */
function buildFormRef(prefix: FormRefPrefix, eventNumber: string, incidentNumber: string): string {
  const seq = nextFormSerial(prefix);
  const evNum = extractRefNumber(eventNumber);
  const incNum = extractRefNumber(incidentNumber);
  return `${prefix}-${seq}-EV-${evNum}-INC-${incNum}`;
}

export function generatePRFRef(eventNumber: string, incidentNumber: string): string {
  return buildFormRef('PRF', eventNumber, incidentNumber);
}

export function generateMIFRef(eventNumber: string, incidentNumber: string): string {
  return buildFormRef('MIF', eventNumber, incidentNumber);
}

export function generatePARRef(eventNumber: string, incidentNumber: string): string {
  return buildFormRef('PAR', eventNumber, incidentNumber);
}
